import OrderModel from '@/models/OrderModel'

export default {
  orders: OrderModel,
  customStatuses: [],
  loading: true
}
